import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Fragment } from 'react';
import classname from 'classnames';
import Checkbox from '../Checkbox/Checkbox';
import { cardGroupClass } from './styles';
import Lazyload from '../Lazyload';

var Item =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Item, _React$Component);

  var _super = _createSuper2(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "handleChange",
    value: function handleChange(value, _, checked) {
      var onChange = this.props.onChange;
      if (onChange) onChange(checked, value);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(content) {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          container = _this$props.container;
      if (!placeholder) return content;
      return (
        /*#__PURE__*/
        React.createElement(Lazyload, {
          container: container,
          placeholder: placeholder
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          className = _this$props2.className,
          container = _this$props2.container,
          children = _this$props2.children,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          others = _objectWithoutProperties(_this$props2, ["style", "className", "container", "children", "placeholder", "value"]);

      var cls = classname(cardGroupClass('item'), className);
      var showCheck = others.checked !== undefined;
      var content =
      /*#__PURE__*/
      React.createElement(Fragment, null, children, showCheck &&
      /*#__PURE__*/
      React.createElement(Checkbox, Object.assign({}, others, {
        onChange: this.handleChange.bind(this, value),
        className: cardGroupClass('checkbox')
      })));
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: cls
        }, this.renderChildren(content))
      );
    }
  }]);

  return Item;
}(React.Component);

export default Item;